import request from "@src/utils/request";

export function getCurrentUser() {
  return request().get("/api/v1/current-user/").send();
}

export function setCurrentUserActiveClinic(clinicId: string) {
  return request()
    .post("/api/v1/current-user/set-active-clinic/")
    .send({ clinicId });
}

export function getUserDisplayInfo(userId: string) {
  return request().get(`/api/v1/users/${userId}/`).send();
}

export function getUsers(filters: Record<string, any> = {}) {
  return request().query(filters).get("/api/v1/users/").send();
}

export function getUserOrderStatistics(userId: string) {
  return request().get(`/api/v1/users/${userId}/order-statistics/`).send();
}
